import { Module } from 'vuex';
import { QuoteForm } from '@/store/models';
import Vue from 'vue';

interface QuoteState {
  creditScore: number;
  cosignerCreditScore: number;
  university: string;
  degree: string;
  quotes: Array<QuoteForm>;
}

const quote: Module<QuoteState, {}> = {
  namespaced: true,
  mutations: {
    addNewQuote(state, quote: QuoteForm) {
      state.quotes.push(quote);
    },

    updateQuoteField(state, { index, value, key }) {
      Vue.set(state.quotes[index], key, value);
    },
  },
  actions: {
    pushQuote(store, quote: QuoteForm) {
      store.commit('addNewQuote', quote);
    },

    setQuoteValue(store, { index, value, key }) {
      store.commit('updateQuoteField', { index, value, key });
    },
  },
};

export default quote;
